import classNames from 'classnames';

import type { TabVariant } from '../Tab/Tab.types';

const variantClassName: { [Key in TabVariant]: string } = {
  outer: 'gap-x-xs',
  inner: 'gap-x shadow-bottom-border-default',
};

export const getTabsClassNames = (
  variant: TabVariant,
  className?: string,
): string => classNames('flex', variantClassName[variant], className);
